module.exports = __webpack_public_path__ + "img/plannedDates.eb508383.svg";